import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { DataGrid } from "components/DataGrid/DataGrid";
import Datepicker from "components/DatePicker/DatePicker";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Headerbar } from "components/Headerbar/Headerbar";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Person } from "components/Person/Person";
import { Position } from "components/Position/Position";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import React, { useEffect, useRef, useState } from "react";
import { MessageType, warehouseIOType } from "types/enum";
import { GUID_EMPTY, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { trans } from "utils/helpers";
import {
  getWarehouseIoNo,
} from "./api";

import { DocsClassification } from "pages/InventoryAndSales/Sales/SalesInvoice/components/DocsClassification/DocsClassification";
import { WarehouseDictionaryWithAccess } from "pages/InventoryAndSales/Sales/SalesInvoice/components/WarehouseDictionary/WarehouseDictionaryWithAccess";
import { DirectDeliveryDetailForm } from "./DirectDeliveryDetailForm";
import { DirectDeliveryDTO } from "./type";
import { DirectDeliverySourceId } from "./DirectDeliverySourceId";

interface Props {
  mode: string;
  showForm: boolean;
  selectedObj: any;
  jobId?: any;
  JobNo?: any;
  processId?: any;
  referenceId?: any;
  taskId?: any;
  onHide: (e) => void;
  reload: () => void;
  warehouseIoEnaumType?: any;
  setShowWarehouseIoForm;
  sourceId?: any;
  SourceData?: any;
  sourceDataParam?: any;
  data?:any
  handleSendData?:any
  constraint?:any
  showWarehouseTypeForm?:any
  initialResponse?:any
  childResponseList?:any
}

export const DirectDeliveryForm = ({
  mode,
  selectedObj,
  onHide,
  taskId,
  jobId,
  JobNo,
  warehouseIoEnaumType,//enum => exmaple DirectDelivery is enum 3 so result is 3
  data,
  handleSendData,
  constraint,
  initialResponse
,
  showWarehouseTypeForm,
  childResponseList
}: Props) => {
  
  const [fromDate, setFromDate] = useState<string | null>(null);
  const [haveSource, setHaveSource] = useState(data?.SourceData?data?.SourceData:null);

  const [resetForm, setResetForm] = useState(false);
  const [recipientPerson, setRecipientPerson] = useState<any>({});
  const [accountPartyPerson, setAccountPartyPerson] = useState<any>({});
  const [deliverPerson, setDeliverPerson] = useState<any>({});
  const [response, setResponse] = useState<any>(data);
  const [applicantPosition, setApplicantPosition] = useState<any>({});
  const [userChanges, setUserChanges] = useState({});

  const [docsClassification, setDocsClassification] = useState<any>({});
  const myform = useRef<any>(null);
  const [warehouseIoDetail, setWarehouseIoDetail] = useState<any>(data?.DirectDeliveryDetailDTOList || []);
  const [detailMode, setDetailMode] = useState<any>([]);

  const [totalRow, setTotalRow] = useState<any>({
    QtyIn1: data?.ItemCount?data?.ItemCount:0,
  });
  const [showDetailForm, setShowDetailForm] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);

    const [warehouseData, setWarehouseData] = useState<any>({
    Warehouse:JSON.parse(localStorage.getItem('DefaultInventory') as any)?.Name,
    WarehouseId:JSON.parse(localStorage.getItem('DefaultInventory') as any)?.Id
  });
  const [time, setTime] = useState(new Date().toISOString());
  const [nextInvoiceNumber, setNextInvoiceNumber] = useState<any>();
  const [requiredFields, setRequiredFields] = useState<any>();
    const [dataChange, setDataChange] = useState<any>(false);

     const handleSourceData = (obj, type) => {
    setResponse(obj);
    setHaveSource(type);

  };
      function selectedInvoiceDetailHandler(data) {

  }



  const getWarehouseIoNoAsync = async () => {
    try {
      const res = await getWarehouseIoNo(
        docsClassification?.Id != GUID_EMPTY ? docsClassification?.Id : null,
       mode=='create' && !jobId?warehouseData?.WarehouseId: response.WarehouseId,
        warehouseIoEnaumType,
        response.WarehouseIONo!==0 || mode!=='create'?response.Id:null
      );
      setNextInvoiceNumber(res.Data);
    } catch (error: any) {}
  };



  

  const handleSubmit = async (e,sendData,detail=warehouseIoDetail) => {
    const dataCollect: DirectDeliveryDTO = {
      SourceId: response?.SourceId??null,
      SourceData: haveSource ? haveSource?.includes("WarehouseIOs")?"WarehouseIOs":haveSource : response?.SourceData?response?.SourceData:null,
      IsRegisteredByQuantity: false,
      IsRegisteredByPrice: false,
      /*       RecipientPersonDescriptionEN: "",
      AccountPartyPersonDescriptionEN: "",
      DeliverPersonDescriptionEN: "",
      ApplicantPositionDescriptionEN: "", */

      ItemCount: totalRow.QtyIn1,
      DocsClassificationId:
        myform.current?.docsClassificationId &&
        myform.current?.docsClassificationId.value !== GUID_EMPTY
          ? myform.current?.docsClassificationId.value
          : null,
      WarehouseIOKindId: myform.current?.WarehouseIOKindId.value?myform.current?.WarehouseIOKindId.value:null,
       WarehouseId:mode=='create' && !jobId?warehouseData.WarehouseId: response.WarehouseId,
      Warehouse:mode=='create' && !jobId?warehouseData.Warehouse:response.Warehouse,
      WarehouseIOType: +warehouseIOType.DirectDelivery,
      WarehouseIONo: parseInt(myform.current?.WarehouseIONo?.value, 10),
      WarehouseIODate: fromDate || "",
      BillOfLadingNo: myform.current?.BillOfLadingNo.value,
      CalculateQuantityFromAnalysis:
      myform.current?.CalculateQuantityFromAnalysis.checked,
      RecipientPersonId: recipientPerson.Id,
      RecipientPersonDescription: recipientPerson.Name,
      AccountPartyPersonId: accountPartyPerson.Id,
      AccountPartyPersonDescription: accountPartyPerson.Name,
      DeliverPersonId: deliverPerson.Id,
      DeliverPersonDescription: deliverPerson.Name,
      ApplicantPositionId: applicantPosition.Id,
      ApplicantPositionDescription: applicantPosition.Name,
      Description: myform.current?.Description?.value,
      DirectDeliveryDetailDTOList: detail,
    };


let url='FromSource' as any
if(jobId)
{
//   const diff1 = warehouseIoDetail?.filter(a => !(initialResponse?.DirectDeliveryDetailDTOList as any).some((b:any)  => b.ItemCode === a.ItemCode));
//  const diff2 = (initialResponse?.DirectDeliveryDetailDTOList as any)?.filter(a => !warehouseIoDetail?.some(b => b.ItemCode === a.ItemCode));
//  const differences = [...diff1, ...diff2];
 
//  const mismatchedQty = warehouseIoDetail?.filter(item1 => {
//    const match = (initialResponse?.DirectDeliveryDetailDTOList as any)?.find(item2 => item2.ItemCode === item1.ItemCode);
//    return match && item1.QtyIn1 !== match.QtyIn1;
//   });
//   if(!!differences?.length){ url='FromSourceWithItemEdit'}
// else if(!!mismatchedQty?.length){ url='FromSourceWithQtyEdit'}


if(initialResponse?.DirectDeliveryDetailDTOList?.length != warehouseIoDetail?.length){
  url='FromSourceWithItemEdit'
}else{
warehouseIoDetail.map(item => {

  let flag = false;

  const foundWithQtyDiff = initialResponse?.DirectDeliveryDetailDTOList.some(res => {

    
    if (item?.ItemCode == res?.ItemCode) {
      flag = true;
      if (item?.QtyIn1 != res?.QtyIn1) {
        url = 'FromSourceWithQtyEdit';
      }
      return true;  // متوقف کردن حلقه some
    }
    return false;
  });

  if (!flag) {

    url = 'FromSourceWithItemEdit';
  }
});



}

}



    handleSendData({...dataCollect, JobId: jobId,
      JobNo: response?.JobNo ? response?.JobNo : JobNo,
      TAS_UID: taskId,
      Id: response?.Id},initialResponse?.SourceId?url:null,sendData);
      // اگر در فرایند باشد و سورس نداشته باشد باید  به ادمیدل درخواست بزند
      // اگر در فرایند باشد و سورس داشته باشه باید به فرامسورس و ... درخواست بزند
      //اگر در فرایند نباشد سورس داشته باشد به فرامسورس درخواست بزند 
      //اگر در فرایند نباشد و سورس نداشته باشد پست معمولی است
    if(sendData){
      showWarehouseTypeForm!=3 &&  onHide &&  onHide(true)
    }  
  };

  const handleCallBackWarehouseIODetail = (newData) => {
      let newItemCount = 0;
          let newItemes=[] as any
    if (detailMode == "create") {
       newItemes=[...warehouseIoDetail, newData]
      setWarehouseIoDetail(newItemes);
      handleSubmit(null,false,newItemes)//برای وقتی از مستر یکی داریم و تا روی دکمه ذخیره کلیک نکنه دیتای دیتیل اپدیت نمیشه پس مجبوریم با هر تغییر دیتیل یکبار دیتارو با صدا زدن تابع اپدیت کنیم بفرستیم بالا
    } else {
       newItemes = warehouseIoDetail?.map((item: any) => {
        if (item.Id == newData.Id) {
          return newData;
        } else {
          return item;
        }
      });
      setWarehouseIoDetail(newItemes);
      handleSubmit(null,false,newItemes)//برای وقتی از مستر یکی داریم و تا روی دکمه ذخیره کلیک نکنه دیتای دیتیل اپدیت نمیشه پس مجبوریم با هر تغییر دیتیل یکبار دیتارو با صدا زدن تابع اپدیت کنیم بفرستیم بالا
    }
       newItemes.map((item) => {
        newItemCount += item.QtyIn1;
      });
    setTotalRow({
      QtyIn1: newItemCount,
    });
  };
  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide && onHide();
      // });
      Toast(trans("modalclosemessage"), MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide && onHide(true);
      });
    } else {
      onHide && onHide(true);
    }
  }


  

  const handleDeleteRow = async (id: string = selectedObj?.Id) => {
    let newPriceListDetail: any = [...warehouseIoDetail];
    let obj = newPriceListDetail.filter((e) => e.Id == id)[0];

    setTotalRow({
      QtyIn1: totalRow.QtyIn1 - obj.QtyIn1,
    });
    const detais=newPriceListDetail.filter((e) => e.Id != id)
    setWarehouseIoDetail(detais);
      handleSubmit(null,false,detais)//برای وقتی از مستر یکی داریم و تا روی دکمه ذخیره کلیک نکنه دیتای دیتیل اپدیت نمیشه پس مجبوریم با هر تغییر دیتیل یکبار دیتارو با صدا زدن تابع اپدیت کنیم بفرستیم بالا

  };

  const selectedObjCallback = (obj, index) => {
    setSelectedRow(obj);
  };

  useEffect(() => {
      setRequiredFields(constraint?.RequiredFields?JSON.parse(constraint?.RequiredFields):null);
      if (constraint?.IsDocClassified   ) {
        if(mode == "create" || response.WarehouseIONo===0){
          getWarehouseIoNoAsync();
        }else{
          setNextInvoiceNumber(response.WarehouseIONo)
        }
      }else{
        if(mode == "create" && !jobId){
          setNextInvoiceNumber(constraint?.DocNoDictionary?.[warehouseData.WarehouseId])
        }
      }

  }, []);

useEffect(()=>{
 setWarehouseIoDetail(data?.DirectDeliveryDetailDTOList?data?.DirectDeliveryDetailDTOList:[])
let newItemCount=0
    data?.DirectDeliveryDetailDTOList.map((item) => {
        newItemCount += item.QtyIn1;
      });
    setTotalRow({
      QtyIn1:newItemCount,
    });

},[data?.DirectDeliveryDetailDTOList])




  return (
    <div className="card">
      {showDetailForm && (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowDetailForm(false);
          }}
          show={showDetailForm}
          title={"warehouseIODetail"}
        >
          <DirectDeliveryDetailForm
            warehouseIODetail={handleCallBackWarehouseIODetail}
            mode={detailMode}
            onHide={() => setShowDetailForm(false)}
            warehouseId={mode=='create'&& !jobId?warehouseData.WarehouseId:response?.WarehouseId}
            WarehouseDetailId={selectedRow?.WarehouseDetailId}
            WarehouseDetail={selectedRow?.WarehouseDetail}
            WarehouseDetailsCount={warehouseData?.WarehouseDetailsCount}
            selectedObj={selectedRow}
            jobId={jobId}
          />
        </ModalForm>
      )}

        <>
          <form className={"card-body"} ref={myform}>      
            <FormWithTitle
              title={
                trans("warehouseIo") +
                " _ " +
                trans("Number") +
                " : " +
         (    constraint?.IsDocClassified || (mode=='create' && !jobId)
                        ? nextInvoiceNumber
                        : response?.WarehouseIONo?  response?.WarehouseIONo?.toString():'')
              }
              defualtClose={true}
              showFristRow={true}
              closeOption={true}
            >
           <div className="row px-2 py-1">
               {/* dont use this component in workflow beacuse we get sourceData from Cartable/DynamicFormsByReferenceId api and should not change it. */}
                                { !jobId   && <div className="col-lg-2 ms-3 col-11">
                                                             
                                                                                <DirectDeliverySourceId
                                                                                  SalesInvoiceDetailCallBack={selectedInvoiceDetailHandler}
                                                                                  invoiceConstraint={constraint}
                                                                                 
                                                                                  SourceObjCallBack={(e, type) => {
                                                                                    handleSourceData(e, type);
                                                                                  }}
                                                                                  value={haveSource ? haveSource : null}
                                                                                  resetForm={resetForm}
                                                                                  dataChange={dataChange}
                                                                                  mode={mode}
                                                                                  warehouseId={warehouseData?.WarehouseId}
                                                                                  SourceDataType={response?.SourceDataType}
                                                                                />
                                                                 </div>}
                <div className="col-11 col-lg-3">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxType="text"
                    labelText="WarehouseIONo"
                    textboxName="WarehouseIONo"
                    resetForm={resetForm}
                    readonly={!constraint?.IsDocNoEditable}
                    defaultValue={
                      constraint?.IsDocClassified || (mode=='create' && !jobId)
                        ? nextInvoiceNumber
                        :  response?.WarehouseIONo?.toString()
                        
                    }
                    mode={constraint.IsDocNoEditable ? mode : "view"}
                    required={requiredFields?.WarehouseIONo}
                  />
                </div>
                {constraint.IsDocClassified && (
                  <div className="col-lg-3 col-11 ">
                    <DocsClassification
                      label="Classification"
                      name="docsClassificationId"
                      baseUrl={INVENTORYANDSALES_URL}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Inventory
                          .BaseDefinitionAndSettingApi
                          .InventoryDocsClassification.dictionary
                      }
                      resetForm={resetForm}
                      value={response?.DocsClassificationId}
                      mode={mode}
                      IsDocClassified={constraint.IsDocClassified}
                      onChange={(e, obj) => {
                        setDocsClassification(obj);
                        if (
                          (e != docsClassification.Id &&
                            nextInvoiceNumber &&
                            !constraint?.IsClassificationIgnored) ||
                          (mode == "edit" &&
                            !response?.DocsClassificationId &&
                            !docsClassification.Id &&
                            constraint?.IsClassificationIgnored)
                        ) {
                          //توضیح کامل شرط:
                          //وقتی مد ایجاد هست شرط اول اجرا شده
                          //وقتی مد ویرایش هست و در ریسپانس مقدار داکس کلسیفیکیش داریم شرط اول اجرا میشه
                          //در مد ادیت اگر ریسپانس مقدار داکس کلسیفیکیشن نداشته باشد شرط دوم اجرا شده به این صورت که چون میخواد جدید داکس کلسیفیکیشن بگیره پس باید درخواست بزنه و شماره جدید بگیره و فقط یکبار باید این اتفاق بیوفته چون ایگنور داریم و دفعات بعدی اگر داکس تغییر کرد نباید شماره جدید بگیره پس باید بررسی کنیم داکس مقدار نداشته باشه و یا ریسپانس داکس مقدار نداشته باشه
                          getWarehouseIoNoAsync();
                        }
                      }}
                    />
                  </div>
                )}

                <div className="col-11 col-lg-3">
                  <DictionarySelectBox
                    baseUrl={INVENTORYANDSALES_URL}
                    endPoint={
                      ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis
                        .warehouseIOKindDictionary
                    }
                    label="type"
                    name="WarehouseIOKindId"
                    params={{
                      warehouseIOType: warehouseIOType.DirectDelivery,
                    }}
                    value={response?.WarehouseIOKindId}
                    mode={mode}
                  />
                </div>
                <div className="col-11 col-lg-3">
                  <Datepicker
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    mode={constraint?.IsNewDocCurrentDate ? "view" : mode}
                    resetForm={resetForm}
                    lable="WarehouseIODate"
                    setIsoTime={(isoTime: string) => {
                      setFromDate(isoTime);
                    }}
                    val={response?.WarehouseIODate ?? time}
                    required={requiredFields?.WarehouseIODate}
                  />
                </div>
                <div className="col-11 col-lg-3">
                  <WarehouseDictionaryWithAccess
                    name="WarehouseId"
                    label="Warehouse"
                    onChange={(e, obj) => {
                      setWarehouseData({
                        WarehouseId: e,
                        WarehouseTitle: obj.Name.Description,
                        WarehouseDetailsCount: obj.Name.WarehouseDetailsCount,
                      });
                    }}
                    mode={'view'}
                    value={!jobId?warehouseData?.WarehouseId:response?.WarehouseId}
                    required={requiredFields?.WarehouseId}
                  />
                </div>

                
                {mode === "view" && (
                  <div className="col-11 col-lg-3">
                    <Position
                      name="RetrievalUser"
                      label="RetrievalUser"
                      value={response?.RetrievalUser}
                      resetForm={resetForm}
                      mode={mode}
                    />
                  </div>
                )}
                {/* <div className="col-lg-3 col-11 mb-3 mb-lg-0">
                  <EnumerationTypeSelect
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    label="WarehouseIOType"
                    enumTypeSelect="WarehouseIOType"
                    name="WarehouseIOType"
                    mode={mode}
                    value={response?.WarehouseIOType}
                  />
                </div> */}

         
                <div className="col-11 col-lg-3">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxType="text"
                    labelText="BillOfLadingNo"
                    textboxName="BillOfLadingNo"
                    resetForm={resetForm}
                    defaultValue={response?.BillOfLadingNo}
                    mode={mode}
                    required={requiredFields?.BillOfLadingNo}
                  />
                </div>
                {/* 
                <div className="col-lg-3 col-11">
                  <EnumerationTypeSelect
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    label="ProductionType"
                    enumTypeSelect="ProductionType"
                    name="ProductionType"
                    mode={mode}
                    value={response?.ProductionType}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <EnumerationTypeSelect
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    label="ValuationType"
                    enumTypeSelect="ValuationType"
                    name="ValuationType"
                    mode={mode}
                    value={response?.ValuationType}
                  />
                </div> */}

                <div className="col-lg-3 col-11">
                  <Person
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    value={response?.RecipientPersonId}
                    resetForm={resetForm}
                    mode={mode}
                    WithSearch={false}
                    setPerson={setRecipientPerson}
                    returnObj={true}
                    name={"RecipientPerson"}
                    label="RecipientPerson"
                    required={requiredFields?.RecipientPersonId}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Person
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    value={response?.AccountPartyPersonId}
                    resetForm={resetForm}
                    mode={mode}
                    WithSearch={false}
                    setPerson={setAccountPartyPerson}
                    returnObj={true}
                    name={"AccountPartyPerson"}
                    label="AccountPartyPerson"
                    required={requiredFields?.AccountPartyPersonId}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Person
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    value={response?.DeliverPersonId}
                    resetForm={resetForm}
                    mode={mode}
                    WithSearch={false}
                    setPerson={setDeliverPerson}
                    returnObj={true}
                    name={"DeliverPerson"}
                    label="DeliverPersonDescription"
                    required={requiredFields?.DeliverPersonId}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Position
                    name="ApplicantPosition"
                    label="ApplicantPositionDescription"
                    resetForm={resetForm}
                    value={response?.ApplicantPositionId}
                    mode={mode}
                    returnObj={true}
                    onChange={setApplicantPosition}
                    required={requiredFields?.ApplicantPositionId}
                  />
                </div>

                {/* <div className="col-11 col-lg-3">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxType="text"
                    labelText="AccountPartyPersonDescription"
                    textboxName="AccountPartyPersonDescription"
                    resetForm={resetForm}
                    defaultValue={response?.AccountPartyPersonDescription}
                    mode={mode}
                  />
                </div> */}
                <div className="col-11 col-lg-6">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="Description"
                    textboxType="textarea"
                    labelText="Description"
                    value={response?.Description}
                    defaultValue={response?.Description}
                    mode={mode}
                    required={requiredFields?.Description}
                  />
                </div>
                <div className="w-100"></div>
                {/* <div className="col-11 col-lg-6">
                  <CheckableButton
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    defaultChecked={
                      response ? response?.AutoGenerateTransferReceipt : false
                    }
                    defaultValue={
                      response ? response?.AutoGenerateTransferReceipt : false
                    }
                    labelText={"AutoGenerateTransferReceipt"}
                    inputName={"AutoGenerateTransferReceipt"}
                    type="checkbox"
                    mode={mode}
                  />
                </div> */}
                <div className="col-11 col-lg-6">
                  <CheckableButton
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    defaultChecked={response?.CalculateQuantityFromAnalysis}
                    defaultValue={response?.CalculateQuantityFromAnalysis}
                    labelText={"CalculateQuantityFromAnalysis"}
                    inputName={"CalculateQuantityFromAnalysis"}
                    type="checkbox"
                    mode={mode}
                  />
                </div>
                {/* <div className="col-12 col-lg-6">
                  <CheckableButton
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    defaultChecked={response?.IsRegisteredByQuantity  }
                    defaultValue={ response?.IsRegisteredByQuantity }
                    labelText={"IsRegisteredByQuantity"}
                    inputName={"IsRegisteredByQuantity"}
                    type="checkbox"
                    mode={mode}
                  />
                </div>
                <div className="col-12 col-lg-6">
                  <CheckableButton
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    defaultChecked={ response?.IsRegisteredByPrice 
                    }
                    defaultValue={ response?.IsRegisteredByPrice 
                    }
                    labelText={"IsRegisteredByPrice"}
                    inputName={"IsRegisteredByPrice"}
                    type="checkbox"
                    mode={mode}
                  />
                </div> */}
              </div>
            </FormWithTitle>
          </form>

          <div className="card-body mt-3 mb-5">
            <div className="row mb-3">
              <div className="col-6 ">
                {(mode != "view" && !haveSource) && (
                  <div
                    onClick={() => {
                      if (warehouseData?.WarehouseId ||(mode=='create' && !jobId)) {
                        setShowDetailForm(true);
                        setDetailMode("create");
                      } else {
                        // Toast("msg-selectedwarehouse", "error");
                        Toast("msg-selectedwarehouse", MessageType.error);
                      }
                    }}
                    className="col-2 mb-1 btn btn-success btn-sm d-flex align-items-center justify-content-between "
                    style={{
                      width: "70px",
                      maxHeight: "30px",
                      marginRight: "20px",
                      minWidth: "70px",
                    }}
                  >
                    <>
                      <span className=" font-size-lg ms-2 ">
                        {trans("add")}
                      </span>
                      <FontAwesomeIcon
                        size="xs"
                        icon={["fas", "plus"]}
                        className="color_text_light d-flex Requests__chatbox-reply-btn mx-1 p-1"
                        color="white"
                      />
                    </>
                  </div>
                )}
              </div>
              <div className="col-6 ">
                <Headerbar
                  withPading={false}
                  headerContents={totalRow}
                  hasBorder={true}
                />
              </div>
            </div>
            <div>
              {(
                mode == "view"
                  ? warehouseIoDetail?.length > 0
                  : constraint?.DetailDTO
              ) ? (
                <>
                  <DataGrid
                    convertDateColNames={["ExpireDate","WarehouseIODate"]}
                    DoubleClick={(e) => {
                      setSelectedRow(e);
                      setDetailMode(mode=='edit'?'edit':'view');
                      setShowDetailForm(true);
                    }}
                    responseList={childResponseList??null}
                    parentName={"warehouseIoDetail"}
                    theadData={
                      mode !== "view"
                        ? Object.keys(constraint?.DetailDTO)
                        : Object.keys(warehouseIoDetail?.[0])
                    }
                    tbodyData={warehouseIoDetail??[]}
                    totalRecords={warehouseIoDetail?.length > 0 ? undefined : 0}
                    scrollHeight={"67vh"}
                    minCellWidth={80}
                    startIndex={19}
                    selectedRowObjectCallback={selectedObjCallback}
                    handleEdit={
                      mode != "view"
                        ? (e) => {
                            setSelectedRow(e);
                            setDetailMode("edit");
                            setShowDetailForm(true);
                          }
                        : undefined
                    }
                    rowSelected={selectedRow}
                    handleDelete={
                      mode != "view"
                        ? (e) => {
                            // Toast(
                            //   trans("msg_deleteconfirm"),
                            //   "warning",
                            //   "alert",
                            //   () => handleDeleteRow(e)
                            // );
                            Toast(
                              trans("msg_deleteconfirm"),
                              MessageType.confirmDelete,
                              () => handleDeleteRow(e)
                            );
                          }
                        : undefined
                    }
                    handleView={(e) => {
                      setSelectedRow(e);
                      setDetailMode("view");
                      setShowDetailForm(true);
                    }}
                  />
                </>
              ) : (
                <Message message={"NoDataForPreview"} type={"info"} />
              )}
            </div>
          </div>
              <div className="mb-2">
              {mode != "view" ? (
                <div className="col-lg-12  btns_form mb-3">
                  <Button
                    // disabled={!(salesOrderDetail.length > 0)}
                    value="save"
                    btnType="submit"
                    disabled={
                      !constraint.NoItemWarehouseIO && !warehouseIoDetail?.length
                    }
                    onClick={(e)=>handleSubmit(e,true)}
                  />

                  <Button
                    btnType="cancel"
                    value="Cancel"
                    onClick={() => {
                      cancel();
                    }}
                  />
                </div>
              ) : (
                <div className="col-lg-12 mt-1 btns_form mb-3">
                  <Button
                    btnType="primary"
                    value="close"
                    onClick={() => {
                      cancel();
                    }}
                  />
                </div>
              )}
            </div>
        </>
      
    </div>
  );
};
